// @flow
import { connect } from 'react-redux'
import IncludedLocationsSelect from './IncludedLocationsSelect'
import type { Store } from '../../redux/ducks'
import _ from 'lodash'
import store from '../../redux/store'
import { patch } from '../AudienceEditContainer'
import type { GroupedArrayParameters } from '../types'
import * as segmentationReducer from '../../redux/ducks/segmentation/reducers'
import getJson from '../../services/getJson'

const GET_CHILDREN_LOCATION_IDS_URL = '/audiences/get_children_location_ids'

function mapStateToProps(state: Store) {
  const audienceState = state.audienceEdit
  const initial = audienceState.initial

  if (!initial) return {}

  return {
    ...selectProperties(initial.locations.includedSelectProperties),
    includedLocationGroups: audienceState.includedLocationGroups,
    errors: audienceState.includedLocationsErrors,
    preloadedLocations: audienceState.preloadedLocations
  }
}

function mapDispatchToProps(dispatch: Function, ownProps) {
  return {
    onChange: (includedLocationGroups: Array<GroupedArrayParameters>) => {
      const data = { location_ids: _.join(_.flatMap(includedLocationGroups, 'value'), ',') }
      getJson(GET_CHILDREN_LOCATION_IDS_URL, data).done((response) =>
        patch(dispatch, { locationsWithChildren: response.data })
      )
      patch(dispatch, { includedLocationGroups: includedLocationGroups })
      ownProps.onChange && ownProps.onChange()
    },
    onLocationsLoad: (locations) => {
      const state: Store = store.getState()
      patch(dispatch, {
        preloadedLocations: _.uniqBy(
          _.concat(state.audienceEdit.preloadedLocations, locations),
          (location) => location.id
        )
      })
    },
    onIncludedLocationGroupAdd: () => {
      dispatch(segmentationReducer.patch({ segmentByLocations: true }))
      patch(dispatch, { useLocationGroupNames: true })
    },
    onIncludedLocationGroupRemove: (includedLocationGroups: Array<GroupedArrayParameters>) => {
      patch(dispatch, { useLocationGroupNames: includedLocationGroups.length > 1 })
    }
  }
}

export function selectProperties(properties: Object): Object {
  if (!properties) return {}

  return {
    ajaxUrl: properties.ajaxUrl,
    ajaxDelay: properties.ajaxDelay,
    labelTitle: properties.labelTitle,
    quickLocationOptions: properties.quickLocationOptions,
    dropdownLocationOptions: properties.dropdownLocationOptions
  }
}

const IncludedLocationsSelectContainer = connect<Object, Object, _, _, _, _>(
  mapStateToProps,
  mapDispatchToProps
)(IncludedLocationsSelect)

export default IncludedLocationsSelectContainer
